import {  useFormikContext,getIn } from 'formik';
import React, { useState, useEffect } from 'react';
import { Input,Container,Col,Row,Button} from 'reactstrap';
import { useEdit } from '../../Services/EditContext';
import useFetch from '../../Services/useFetch';
import {  endpoints } from '../../utils/Constants';
import { FormLabel, FormValue } from './FormLabel';
import ErrorMessage from './ErrorMessage';
import Selector from './Selector';
import entities from '../../utils/entities';
import EditorTitle from '../Models/EditorTitle';
import ReactImageGallery from 'react-image-gallery';
import Modal from '../Models/Modal'
import LoadingAnimation from './LoadingAnimation';

const AircraftSelector = (props) => {
    const { noEdit, index,useAllId,label, id, isMulti,route,routeField,passengerLimitField,compare, ...myProps } = props;
    const [selection, setSelection] = useState();
    const [options, setOptions] = useState();
    const { setFieldValue, values } = useFormikContext();
    const [supplierId, setSupplierId] = useState();
    
    const [edit] = useEdit();
    
    const [aircraft, loading, error] = useFetch((edit && !noEdit && supplierId) ? endpoints.getAllActiveAircraftForSupplier + supplierId : null);
    const value = route?route[routeField]:null;
    const originalRoute = values?.original?.routes[index];
    const original = originalRoute && originalRoute[routeField] ? originalRoute[routeField] : [{ type: "Not Defined", licenseNumber: "" }];

    const useAll = useAllId ? getIn(values, useAllId) : null;   
    useEffect(() => {
        if (supplierId !== values.bidderId) {
            setSupplierId(values.bidderId);
        }
    },[values.bidderId,supplierId]);    
   
    useEffect(() => {

        const options = aircraft ? aircraft.map((m) => { return { id: m.id, value: m.id, label: m.licenseNumber + '-' + m.type, passengerLimit: m.passengerLimit, ...m }; }) : null;
        setOptions(options)
    }, [aircraft]);
    useEffect(() => {
        if (options) {
            if (value) {
                if (!isMulti) {
                    setSelection(options.filter(x => { return value === x.label }));
                } else {

                    const list = value?value:[];
                    const newOps = list.map(x => options.find(y => x.id === y.id));
                    setSelection(newOps)
                }
            }
            else {
                setSelection()
            }
        }
    }, [value, options, isMulti]);


    const onSelectChange = val => {
       
        if (passengerLimitField) {
            const limit = isMulti && val? val.reduce((a, b) => { return  a+ (b.passengerLimit || 0) }, 0) : 0;
            setFieldValue(passengerLimitField,limit.toString())
        }
        setFieldValue(id, val);
        if (useAll) {
            const limit = isMulti && val ? val.reduce((a, b) => { return a + (b.passengerLimit || 0) }, 0) : 0;
            for (var i = 1; i < values.routes.length; i++) {
                setFieldValue('routes[' + i + '].aircraft', val);
                setFieldValue('routes[' + i + '].passengerLimit', limit);
            
            }
        }
    }
    const handleChange = (e) => {
        const checked = e.target.checked

        if (checked) {
            const ac = getIn(values, id);
            const pl = getIn(values, passengerLimitField);
            for (var i = 1; i < values.routes.length; i++) {
                setFieldValue('routes[' + i + '].aircraft', ac);
                setFieldValue('routes[' + i + '].passengerLimit', pl);

            }
        }
        setFieldValue(useAllId, checked);
       
    }
    const compareValue = compare &&
        values.original && values.original.routes &&
        values.original.routes.length && 
        values.original.routes.length <= index && 
        ( values.original?.routes?.length !== value?.routes?.length  ||
             values.original.filter((x, i) => {
                return value[i].licenseNumber !== x.licenseNumber
            }).length);

    const Airplane = ({ plane }) => {
        const [id, setId] = useState();
        
        const onClick = () => {
            setId(plane.id)
        }
        const [imageList, loading, error] = useFetch(id ? endpoints.getAircraftImages + id : null);
        const [images, setImages] = useState([]);
        useEffect(() => {
            if (imageList) {
                const images = imageList.map(x => ({ original: [x.contentType, x.file].join(",") }))
                setImages(images);
            }
        }, [imageList]);

        return <Row>
            {error ? <h6>Error loading images</h6> : null}
           
            {plane.imageCount ? <Button className='link' onClick={onClick}> {plane.type + ' ' + plane.licenseNumber}</Button> :  plane.type + ' ' + plane.licenseNumber}
            <Modal open={id ? true : false} onClose={() => setId()} title={<EditorTitle entity={entities.aircraftImages} />}>
               <ReactImageGallery items={images ? images : []} />
            </Modal>
            {loading ? <LoadingAnimation height={50} /> : null}
        </Row>
    }
    
    return <React.Fragment>
        {error ? <h6>Error loading</h6> : null}
        
        <FormLabel htmlFor={id} style={{ display: 'block' }}>
            <Row><Col sm='6'>{label}</Col><Col sm='6' >{edit && !noEdit && useAllId && index===0 ? <FormLabel check htmlFor={useAllId} style={{ display: 'block !important' }}>
                <Input type='checkbox' id={useAllId} name={useAllId} placeholder="Same For All" checked={useAll} onChange={handleChange} />
                Same for all </FormLabel> : null}</Col></Row>
        </FormLabel>
        {error ? <h4>Error</h4> : null}
        {edit && !noEdit && !loading && (!useAll || index === 0) ? <Selector style={{ width: '100%' }} id={id} hideAllButton size='sm' onChange={onSelectChange} isMulti={isMulti} value={selection} options={options?options:[]} {...myProps} />
            : <React.Fragment>
                {compareValue ? <FormValue style={{ color: 'red' }}><del>{original && original.length ? original.map(x => x.type + ' ' + x.licenseNumber).join(',') : null}</del></FormValue> : null}
                <FormValue><Container>{value && value.length ? value.map((x, i) => <Airplane key={i} plane={x}/>) : null}</Container></FormValue>
            </React.Fragment>}
        {loading ? <LoadingAnimation height={50} /> : null}
        <ErrorMessage name={id} />
    </React.Fragment>
};
export default AircraftSelector;

